// // src/components/TargetAudienceSection.jsx
// import React from 'react';
// import { motion } from 'framer-motion';
// import { useInView } from 'react-intersection-observer';
// import { 
//   FaBriefcase, 
//   FaGlobe, 
//   FaUsers, 
//   FaHeart, 
//   FaGlassCheers, 
//   FaCalendarCheck,
//   FaStar,
//   FaUserTie
// } from 'react-icons/fa';

// const TargetAudienceSection = () => {
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.1,
//   });

//   // Target audience data
//   const audiences = [
//     {
//       icon: <FaBriefcase />,
//       title: "Corporate Executives",
//       description: "Business leaders & professionals",
//       color: "from-blue-500 to-blue-600",
//       bgColor: "bg-blue-50"
//     },
//     {
//       icon: <FaGlobe />,
//       title: "International Visitors",
//       description: "Diplomats & global travelers",
//       color: "from-green-500 to-green-600",
//       bgColor: "bg-green-50"
//     },
//     {
//       icon: <FaUsers />,
//       title: "Families",
//       description: "Vacations & family gatherings",
//       color: "from-orange-500 to-orange-600",
//       bgColor: "bg-orange-50"
//     },
//     {
//       icon: <FaHeart />,
//       title: "Couples",
//       description: "Refined getaways & romance",
//       color: "from-pink-500 to-pink-600",
//       bgColor: "bg-pink-50"
//     },
//     {
//       icon: <FaGlassCheers />,
//       title: "Private Celebrations",
//       description: "Special occasions & events",
//       color: "from-purple-500 to-purple-600",
//       bgColor: "bg-purple-50"
//     },
//     {
//       icon: <FaCalendarCheck />,
//       title: "Extended Stays",
//       description: "Long-term comfort & privacy",
//       color: "from-amber-500 to-amber-600",
//       bgColor: "bg-amber-50"
//     }
//   ];

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.1,
//         delayChildren: 0.2,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 30, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: { 
//         type: "spring",
//         stiffness: 80,
//         damping: 12,
//         duration: 0.6 
//       }
//     },
//   };

//   return (
//     <section className="py-12 bg-gradient-to-b from-[#f1f1f1] via-[#f1f1f1]/0 to-[#f1f1f1]/0 relative overflow-hidden">


//       <div className="container-custom relative z-10">
//         {/* Section Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={inView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.6 }}
//           className="text-center max-w-4xl mx-auto mb-8 space-y-2"
//         >
//          <div className="flex items-center justify-center gap-3">
//             <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//             <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
//              Who We Serve
//             </span>
//             <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//           </div>
          
//           <h2  className="text-4xl md:text-5xl font-light text-[#1a2b3c] leading-tight !mb-4">
//             For Business. For Family.{' '}
//             <span className="font-bold text-[#c9a86c]">For Special Moments.</span>
//           </h2>
          
//           <p className="md:text-[17px] 2xl:text-lg mb-10 text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
//             Stay IN is designed for every lifestyle and occasion, with professional hospitality and attention to detail.
//           </p>
//         </motion.div>

//         {/* Audience Grid */}
//         <motion.div
//           ref={ref}
//           variants={containerVariants}
//           initial="hidden"
//           animate={inView ? "visible" : "hidden"}
//           className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
//         >
//           {audiences.map((audience, index) => (
//             <motion.div
//               key={index}
//               variants={itemVariants}
//               whileHover={{ 
//                 y: -5,
//                 transition: { duration: 0.2 }
//               }}
//               className="group p-8 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 hover:border-gray-100"
//             >
             
              
//                <div className="w-14 h-14 bg-[#c9a86c]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#c9a86c] transition">
//                   <div className="text-[#c9a86c] text-xl group-hover:text-white transition">
//                     {audience.icon}
//                   </div>
//                 </div>

//               {/* Content */}
//               <h3 className="text-md font-bold text-[#1a2b3c] mb-3">
//                 {audience.title}
//               </h3>
              
//               <p className="2xl:text-lg text-gray-600">
//                 {audience.description}
//               </p>
//             </motion.div>
//           ))}
//         </motion.div>

//         {/* Closing Statement */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={inView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.6, delay: 0.6 }}
//           className="text-center md:mt-12 mt-6"
//         >
//              <p className="text-gray-600 text-[17px] 2xl:text-lg">
//               We adapt to every lifestyle and occasion with professional hospitality and attention to detail
//             </p>
          
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default TargetAudienceSection;




// src/components/TargetAudienceSection.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { 
  FaBriefcase, 
  FaGlobe, 
  FaUsers, 
  FaHeart, 
  FaGlassCheers, 
  FaCalendarCheck,
  FaStar,
  FaUserTie
} from 'react-icons/fa';

const TargetAudienceSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Target audience data
  const audiences = [
    {
      icon: <FaBriefcase />,
      title: "Corporate Executives",
      description: "Business leaders & professionals",
      category: "Business Travelers"
    },
    {
      icon: <FaGlobe />,
      title: "International Visitors",
      description: "Diplomats & global travelers",
      category: "International Guests"
    },
    {
      icon: <FaUsers />,
      title: "Families",
      description: "Vacations & family gatherings",
      category: "Family Travel"
    },
    {
      icon: <FaHeart />,
      title: "Couples",
      description: "Refined getaways & romance",
      category: "Romantic Getaways"
    },
    {
      icon: <FaGlassCheers />,
      title: "Private Celebrations",
      description: "Special occasions & events",
      category: "Events & Celebrations"
    },
    {
      icon: <FaCalendarCheck />,
      title: "Extended Stays",
      description: "Long-term comfort & privacy",
      category: "Long-term Stays"
    }
  ];

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { 
        type: "spring",
        stiffness: 80,
        damping: 12,
        duration: 0.6 
      }
    },
  };

  return (
    <>
      {/* SEO Meta Tags for Target Audience */}
      <Helmet>
        <title>Perfect for Business & Family | StayIN Centaurus Islamabad</title>
        <meta name="description" content="StayIN Centaurus caters to corporate executives, families, couples, international visitors, and extended stays. Experience luxury serviced apartments designed for every lifestyle and occasion in Islamabad." />
        <meta name="keywords" content="corporate apartments Islamabad, family serviced apartments, extended stay Islamabad, business travelers Islamabad, couples getaway Islamabad, international visitors Islamabad, StayIN audience" />
      </Helmet>

      {/* Schema Markup for Audience Targeting */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "StayIN Serviced Apartments",
          "serviceType": "Luxury Serviced Apartments",
          "provider": {
            "@type": "Organization",
            "name": "StayIN Hospitality"
          },
          "audience": audiences.map(audience => ({
            "@type": "Audience",
            "name": audience.title,
            "description": audience.description,
            "audienceType": audience.category
          })),
          "areaServed": {
            "@type": "City",
            "name": "Islamabad"
          }
        })}
      </script>

      <section 
        className="py-12 bg-gradient-to-b from-[#f1f1f1] via-[#f1f1f1]/0 to-[#f1f1f1]/0 relative overflow-hidden"
        aria-label="Target audience - Who we serve at StayIN Centaurus Islamabad"
      >
        <div className="container-custom relative z-10">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center max-w-4xl mx-auto mb-8 space-y-2"
          >
            <div className="flex items-center justify-center gap-3">
              <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
              <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
                Who We Serve
              </span>
              <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-light text-[#1a2b3c] leading-tight !mb-4">
              For Business. For Family.{' '}
              <span className="font-bold text-[#c9a86c]">For Special Moments.</span>
            </h2>
            
            <p className="md:text-[17px] 2xl:text-lg mb-10 text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
              Stay IN is designed for every lifestyle and occasion, with professional hospitality and attention to detail.
            </p>
          </motion.div>

          {/* Audience Grid */}
          <motion.div
            ref={ref}
            variants={containerVariants}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
          >
            {audiences.map((audience, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                whileHover={{ 
                  y: -5,
                  transition: { duration: 0.2 }
                }}
                className="group p-8 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 hover:border-gray-100"
              >
                <div className="w-14 h-14 bg-[#c9a86c]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#c9a86c] transition">
                  <div className="text-[#c9a86c] text-xl group-hover:text-white transition" aria-hidden="true">
                    {audience.icon}
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-md font-bold text-[#1a2b3c] mb-3">
                  {audience.title}
                </h3>
                
                <p className="2xl:text-lg text-gray-600">
                  {audience.description}
                </p>
              </motion.div>
            ))}
          </motion.div>

          {/* Closing Statement */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="text-center md:mt-12 mt-6"
          >
            <p className="text-gray-600 text-[17px] 2xl:text-lg">
              We adapt to every lifestyle and occasion with professional hospitality and attention to detail
            </p>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default TargetAudienceSection;